import React, {FC} from 'react'
import Icon from '@/components/Icon'
import {Row, Col} from "antd";
import classnames from 'classnames'

import './style/FileOpearNav.less'

import StylesType from '@/types/StylesType'
import {SelectIndexType} from '@/stores/base/UploadStore'
import {Nav} from './index'


export interface FileOpearNavTypes {
  seletIndex: SelectIndexType;
  changeSelectIndex: (index: SelectIndexType) => void
  navList: Nav[]
}
export type FileOpearNavProps = StylesType & FileOpearNavTypes



const FileOpearNav: FC<FileOpearNavProps> = props => {
  const {className, prefixCls='gc_', seletIndex, changeSelectIndex, navList} = props
  return (
    <>
      <Row className={classnames(className, prefixCls+'file_opear_navs')}>
        {navList.map(nav=> {
          return (
            <Col key={nav.key} className={classnames(prefixCls+'file_opear_nav', {actived: nav.key===seletIndex})} onClick={() => changeSelectIndex(nav.key)}>
              <Icon type={nav.icon}/>
              <span>{nav.title}</span>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default FileOpearNav
